import { render, staticRenderFns } from "./firma.vue?vue&type=template&id=386594aa&scoped=true"
import script from "./firma.vue?vue&type=script&lang=js"
export * from "./firma.vue?vue&type=script&lang=js"
import style0 from "./firma.vue?vue&type=style&index=0&id=386594aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386594aa",
  null
  
)

export default component.exports